import React, { useState } from 'react';
import { handleFooterAccordian } from '../../../../../utils/common';
import Icon from '../../../../basic/icons';
import { ISubLinksHeaderProps } from '../../IFooter';
import { useTranslator } from '../../../header/locales-provider';

const SubLinksHeader = ({ navigationHeader, accordianCls }: ISubLinksHeaderProps): JSX.Element => {
  const handleAccordian = (cls: string) => {
    const _el: any = document.querySelector(`.${cls}`);
    const _elAccordian: any = document.querySelector(`.${cls}-accordian`);
    handleFooterAccordian(_el, _elAccordian);
    setShowDetails(!showDetails);
  };
  const title = navigationHeader?.toLowerCase();
  const locales = useTranslator('global');
  const [showDetails, setShowDetails] = useState(false);

  return (
    <div
      className="flex flex-row justify-between"
      onClick={(e: any) => handleAccordian(accordianCls as string)}
      data-testid="handleAccordianBtn"
    >
      
      <div className={`${accordianCls}-accordian add-circle flex justify-start items-center pr-3`}>
        <Icon name={showDetails ? "removeCircle" : "addCircle"} className="text-white" />
      </div>
      <div className="flex-auto">
        <p aria-hidden={title === 'learn more'} className="text-white font-medium text-base whitespace-pre-wrap">{navigationHeader}</p>
        {title === 'learn more' && <p className="text-white font-medium sr-only text-base whitespace-pre-wrap">{locales?.['aria.learnmore.title']}</p>}
      </div>
    </div>
  );
};

export default SubLinksHeader;
